import { printOssHtml } from "../lib/oss/print";
import {
  expandTerapieForPrintRows,
  formatDataIt,
} from "./terapieExtraFormat";

function escapeHtml(text) {
  if (text == null) return "";
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function apriFinestraStampa(html) {
  const w = window.open("about:blank", "_blank");
  if (w) {
    try {
      w.opener = null;
    } catch {
      /* ignore */
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
    return true;
  }
  return false;
}

function renderTerapieTable(rows) {
  if (rows.length === 0) {
    return '<p class="empty">Nessuna terapia attiva.</p>';
  }

  const body = rows
    .map(
      (row) => `
        <tr>
          <td>${escapeHtml(row.dataInizio || "")}</td>
          <td>${escapeHtml(row.dataFine || "")}</td>
          <td class="farmaco">${escapeHtml(row.farmaco)}</td>
          <td>${escapeHtml(row.posologia)}</td>
          <td class="orario">${escapeHtml(row.orario || "—")}</td>
        </tr>`
    )
    .join("");

  return `
    <table class="terapie-table">
      <thead>
        <tr>
          <th>Dalla Data</th>
          <th>Alla Data</th>
          <th>Farmaco/Principio attivo</th>
          <th>Posologia</th>
          <th>Orari</th>
        </tr>
      </thead>
      <tbody>${body}</tbody>
    </table>`;
}

export function generaHtmlStampaTerapieAttive(ospiteInfo = {}, terapieAttive = []) {
  const nome = String(ospiteInfo.nome ?? "").trim();
  const cognome = String(ospiteInfo.cognome ?? "").trim();
  const codiceFiscale = String(ospiteInfo.codice_fiscale ?? "").trim();
  const struttura = String(ospiteInfo.struttura_nome ?? "").trim();
  const titoloOspite = [cognome, nome].filter(Boolean).join(" ") || "Ospite";

  const rows = expandTerapieForPrintRows(terapieAttive);
  const terapieHtml = renderTerapieTable(rows);
  const dataStampa = new Date().toLocaleDateString("it-IT");

  const extraInfo = [
    ospiteInfo.data_nascita ? `Data di nascita: ${formatDataIt(ospiteInfo.data_nascita)}` : "",
    ospiteInfo.camera ? `Camera: ${ospiteInfo.camera}` : "",
    ospiteInfo.numero_cartella ? `N. cartella: ${ospiteInfo.numero_cartella}` : "",
  ]
    .filter(Boolean)
    .join(" · ");

  return `<!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="utf-8" />
  <title>Terapie in corso — ${escapeHtml(titoloOspite)}</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: Arial, Helvetica, sans-serif;
      margin: 18mm 14mm;
      color: #111;
      font-size: 11px;
      line-height: 1.35;
    }
    .header {
      margin-bottom: 14px;
    }
    .struttura {
      text-align: right;
      font-size: 10px;
      color: #444;
      margin-bottom: 8px;
    }
    h1 {
      font-size: 16px;
      margin: 0 0 10px;
      font-weight: 700;
      text-align: center;
      letter-spacing: 0.02em;
    }
    .ospite-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1.2fr;
      gap: 4px 16px;
      margin-bottom: 6px;
      font-size: 11px;
    }
    .ospite-grid .label {
      font-weight: 700;
    }
    .extra-info {
      font-size: 10px;
      color: #555;
      margin-bottom: 12px;
    }
    .terapie-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }
    .terapie-table th,
    .terapie-table td {
      border: 1px solid #333;
      padding: 5px 6px;
      vertical-align: top;
      word-wrap: break-word;
    }
    .terapie-table th {
      background: #f0f0f0;
      font-weight: 700;
      text-align: center;
      font-size: 10px;
    }
    .terapie-table td.farmaco {
      font-weight: 600;
    }
    .terapie-table td.orario {
      text-align: center;
      white-space: nowrap;
      width: 10%;
    }
    .terapie-table th:nth-child(1),
    .terapie-table td:nth-child(1),
    .terapie-table th:nth-child(2),
    .terapie-table td:nth-child(2) {
      width: 11%;
      text-align: center;
    }
    .terapie-table th:nth-child(3),
    .terapie-table td:nth-child(3) {
      width: 24%;
    }
    .terapie-table th:nth-child(4),
    .terapie-table td:nth-child(4) {
      width: 44%;
    }
    .footer {
      margin-top: 18px;
      padding-top: 8px;
      border-top: 1px solid #ccc;
      font-size: 10px;
      color: #555;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .empty {
      text-align: center;
      color: #666;
      padding: 24px 0;
    }
    @media print {
      body { margin: 10mm; }
      .terapie-table { page-break-inside: auto; }
      .terapie-table tr { page-break-inside: avoid; }
    }
  </style>
</head>
<body>
  <div class="header">
    ${struttura ? `<div class="struttura">${escapeHtml(struttura)}</div>` : ""}
    <h1>Terapie in corso</h1>
    <div class="ospite-grid">
      <div><span class="label">Nome:</span> ${escapeHtml(nome || "—")}</div>
      <div><span class="label">Cognome:</span> ${escapeHtml(cognome || "—")}</div>
      <div><span class="label">Codice Fiscale:</span> ${escapeHtml(codiceFiscale || "—")}</div>
    </div>
    ${extraInfo ? `<div class="extra-info">${escapeHtml(extraInfo)}</div>` : ""}
  </div>

  ${terapieHtml}

  <div class="footer">
    <span>Stampato il ${escapeHtml(dataStampa)} · ${rows.length} ${rows.length === 1 ? "riga" : "righe"}</span>
    <span>Pagina 1 di 1</span>
  </div>

  <script>window.onload = function () { window.print(); };</script>
</body>
</html>`;
}

export function stampaTerapieAttive(ospiteInfo = {}, terapieInCorso = []) {
  const terapieAttive = (terapieInCorso || []).filter((te) => te.attiva !== false);
  if (terapieAttive.length === 0) {
    return { ok: false, reason: "no_active" };
  }
  const html = generaHtmlStampaTerapieAttive(ospiteInfo, terapieAttive);
  // App OSS nativa: stampa di sistema (i popup about:blank nella WebView non si vedono)
  if (printOssHtml(html, "Terapie attive")) return { ok: true, reason: null, native: true };
  const opened = apriFinestraStampa(html);
  return { ok: opened, reason: opened ? null : "popup_blocked" };
}
